import {sendSupportTicket} from './sendSupportTicket';
import {PopupIds} from '../constants/PopupIds';
import {Localization} from '../localization/localization';
import {hideClientAndShowPopup, hidePopupsAndShowClient} from '../general/modules/popupFunctions';

let supportTicket: JQuery;
let supportSuccess: JQuery;
let ticketInProgress: boolean = false;

function closeExpandedSelect(): void {
    if (supportTicket.find('.options').attr('data-expanded') === 'true') {
        supportTicket.find('.options').slideUp(function() {
            supportTicket.find('.options').attr('data-expanded', 'false');
        });
    }
}

function onSelectOptionClick() {
    if (supportTicket.find('.options').attr('data-expanded') === 'false') {
        supportTicket.find('.options').slideDown(function() {
            supportTicket.find('.options').attr('data-expanded', 'true');
        });
    } else {
        supportTicket.find('.options').slideUp(function() {
            supportTicket.find('.options').attr('data-expanded', 'false');
        });
    }
}

async function supportSubmitHandler(e: Event) {
    let data;
    let _self: HTMLElement;

    e.preventDefault();

    _self = this as HTMLElement;

    if (ticketInProgress) {
        return;
    }

    ticketInProgress = true;

    data = {
        subject: $('#support_ticket_subject', _self).val(),
        body: $('#support_ticket_body').val(),
        type: $('#support_ticket_type', _self).text(),
        email: $('#support_ticket_email', _self).val(),
        browser: window.app.config.user_browser,
        ua: window.app.config.user_agent,
        hasPayment: false,
        nickname: 'N/A',
        language: window.app.config.language
    };

    const error = supportTicket.find('.support_ticket_error');
    let result: string | boolean;
    try {
        result = await sendSupportTicket(data);
    } catch (e) {
        console.error(error);
        error.text(Localization._n('support.common')).show();
        return;
    } finally {
        ticketInProgress = false;
    }

    if (result === true) {
        error.hide();
        supportTicket.find('input').val('');
        supportTicket.find('textarea').val('');
        supportTicket.hide();
        supportSuccess.show();
        hidePopupsAndShowClient();
        hideClientAndShowPopup(PopupIds.SUPPORT_SUCCESS);
    } else {
        error.text(Localization._n('support.common')).show();
    }
}

export const initSupportTicketWindow = function() {
    /* support from game_general */
    supportTicket = $('#support_ticket');
    supportSuccess = $('#support_success');

    $('.js_feedback_success', supportSuccess).on('click', function() {
        supportSuccess.hide();
    });

    $(document).on('click', closeExpandedSelect);
    supportTicket.find('.select').on('click', onSelectOptionClick);

    supportTicket.find('.option').on('click', function(e) {
        e.stopPropagation();
        const chosen = supportTicket.find('.chosen');
        const text = $.trim($(this).text());

        if (chosen[0].nodeName.toLowerCase() === 'input') {
            chosen.attr('value', text);
        } else {
            chosen.text(text);
        }

        supportTicket.find('select option').text($(this).data('value') as string);
        supportTicket.find('.options').slideUp(function() {
            supportTicket.find('.options').attr('data-expanded', 'false');
        });
    });

    supportTicket.find('form').on('submit', supportSubmitHandler);
};
